import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "88",
  height: "48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M0 0h88v48H0V0Z",
      fill: "var(--td-component-border)"
    }, null, -1),
    _createElementVNode("path", {
      d: "M42.863 14.052v2.708h1.625v-2.708h-1.625Z",
      fill: "var(--td-text-color-primary)"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M38.349 23.982a5.326 5.326 0 1 1 10.653 0 5.326 5.326 0 0 1-10.653 0Zm5.326-3.701a3.701 3.701 0 1 0 0 7.403 3.701 3.701 0 0 0 0-7.403ZM52.208 26.781h-2.621l-2.06 6.699 1.552.478.511-1.661h2.614l.511 1.66 1.554-.477-2.061-6.699Zm-.503 3.89-.697-2.265h-.221l-.697 2.266h1.615Z",
      fill: "var(--td-text-color-primary)"
    }, null, -1),
    _createElementVNode("path", {
      d: "m48.208 18.3 1.915-1.914 1.149 1.15-1.915 1.914-1.15-1.15ZM53.606 23.17h-2.709v1.625h2.709V23.17ZM44.488 31.204v2.709h-1.625v-2.708h1.625ZM37.228 31.579l1.915-1.915-1.15-1.15-1.914 1.916 1.149 1.149ZM36.453 24.795h-2.708V23.17h2.708v1.625ZM36.079 17.535l1.915 1.915 1.149-1.15-1.915-1.914-1.15 1.15Z",
      fill: "var(--td-text-color-primary)"
    }, null, -1)
  ])))
}
export default { render: render }